import React from "react";
import {NavLink, useParams} from "react-router-dom";

function AdminClientBillingNavTab() {
    let {client} = useParams();
    return (
        <div className="col-lg-2 col-md-3">
            <div className="setting_sidebar">
                <div className="nav nav-tab " id="nav-tab" role="tablist">
                    <NavLink to={'/back-admin/client-portal/' + client + '/billing'} className="nav-link ps-3 mb-1" end>
                        {/* <img src="/images/Billing_Overview.webp" alt="..." className="me-2"/> */}
                        Billing Overview
                    </NavLink>
                    <NavLink to={"/back-admin/client-portal/" + client + "/billing/history"} className="nav-link ps-3 mb-1">
                        {/* <img src="/images/Billing_History.webp" alt="..." className="me-2"/> */}
                        Billing History
                    </NavLink>
                    <NavLink to={"/back-admin/client-portal/" + client + "/billing/credit-history"}
                             className="nav-link ps-3 mb-1">
                        {/* <img src="/images/Credit_History.png" alt="..." className="me-2"/> */}
                        Credit History
                    </NavLink>
                    <NavLink to={"/back-admin/client-portal/" + client + "/billing/pricing"} className="nav-link ps-3 mb-1">
                        {/* <img src="/images/Pricing_Plan.webp" alt="..." className="me-2"/> */}
                        Pricing Plan
                    </NavLink>
                </div>
            </div>
        </div>
    );
}

export default AdminClientBillingNavTab;